import { render, staticRenderFns } from "./Module9Item.vue?vue&type=template&id=856bca6c&scoped=true&"
import script from "./Module9Item.vue?vue&type=script&lang=js&"
export * from "./Module9Item.vue?vue&type=script&lang=js&"
import style0 from "./Module9Item.vue?vue&type=style&index=0&id=856bca6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856bca6c",
  null
  
)

export default component.exports